import { render, staticRenderFns } from "./cham-chuancan.vue?vue&type=template&id=7771accd&scoped=true"
import script from "./cham-chuancan.vue?vue&type=script&lang=js"
export * from "./cham-chuancan.vue?vue&type=script&lang=js"
import style0 from "./cham-chuancan.vue?vue&type=style&index=0&id=7771accd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7771accd",
  null
  
)

export default component.exports